<ng-container *transloco="let t; read: 'calculator_result.analysis-table'">

  <psc-section-title
    [title]="t('title')"
    alignment="left"
    size="normal"
    [lineWidthPercentage]="100"
    [lineThickness]="2"></psc-section-title>

  <table class="overflow-auto table-auto analysis-table mt-6 text-color-blue1 w-full">
    <thead>
    <tr class="{{cssClasses}}">
      <th class="empty-header"></th>
      <th *ngFor="let header of headers">{{header}}</th>
    </tr>
    </thead>
    <tbody class="whitespace-nowrap">
    <tr class="{{cssClasses}}">
      <td>{{t('system-capacity')}}</td>
      <td *ngFor="let result of solarCalculatorResult.additionalResults">
        {{result.systemCapacity | number:'1.0-2'}} kW
      </td>
    </tr>
    <tr class="{{cssClasses}}">
      <td>{{t('annual-savings')}}</td>
      <td *ngFor="let result of solarCalculatorResult.additionalResults">
        {{result.annualSavingMoney | number:'1.0-2'}} {{solarCalculatorResult.currency}}
      </td>
    </tr>
    <tr class="{{cssClasses}}">
      <td>{{t('system-efficiency')}}</td>
      <td *ngFor="let result of solarCalculatorResult.additionalResults">
        {{result.selfSufficiencyPercentage | number:'1.0-0'}} %
      </td>
    </tr>
    <tr class="{{cssClasses}}">
      <td>{{t('return-on-investment')}}</td>
      <td *ngFor="let result of solarCalculatorResult.additionalResults">
        {{result.investmentReturn | number:'1.0-1'}}
      </td>
    </tr>
    </tbody>
  </table>

</ng-container>
